"use client";

import React from "react";
import styles from "./dark-mode-btn.module.css";
import { FaRegMoon } from "react-icons/fa";
import { PiSunDimDuotone } from "react-icons/pi";
import { useTheme } from "../../utils/theme";
import clsx from "clsx";
import LiquidGlassFilter from "./liquid-glass-filter";

function DarkModeBtn() {
  const { theme, toggleTheme } = useTheme();

  return (
    <LiquidGlassFilter>
      <div className={styles['dark-btn-container']} onClick={toggleTheme}>
          <span className={`${styles["sun-icon"]} ${theme === "dark" ? styles["left"] : styles["right"]}`}>
            <PiSunDimDuotone color="#FF6d10" size={22} />
          </span>
          <div className={clsx({[styles.bounce] : theme === "dark"})}><FaRegMoon color={theme !== "dark" ? "#e5e5e5" : "white"} size={20} /></div>
          <div className={clsx({[styles.bounce] : theme === "light"})}><PiSunDimDuotone color={theme !== "light" ? "#e5e5e5" : "white"} size={22} /></div>
      </div>
    </LiquidGlassFilter>  
    
  )
}

export default DarkModeBtn;

